import { z } from "zod";
import {
  roleSelectionSchema,
  defaultRoleSelectionValues,
} from "./role-selection.schema";
import {
  sirenOrSiretSchema,
  vatSchema,
  validateVatWithSiren,
} from "../utils/auth_utils.schema";

export const newProfessionalFormSchema = roleSelectionSchema
  .extend({
    businessName: z.string().nullable().optional(),
    siret: sirenOrSiretSchema.nullable().optional(),
    vat: vatSchema.nullable().optional(),
    country: z.string().min(1, "Pays est requis").optional(),
  })
  .superRefine((form, ctx) => {
    const { siret, vat } = form;

    if (siret === null && vat !== null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Vous devez renseigner le numéro de SIRET",
        path: ["siret"],
      });
    }

    validateVatWithSiren(ctx, vat, siret);
  });

export const defaultNewProfessionalFormValues = {
  ...defaultRoleSelectionValues,
  businessName: null,
  siret: "",
  vat: "",
  country: "",
};

export type NewProfessionalForm = z.infer<typeof newProfessionalFormSchema>;
